/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShadowComponentCriterionDetail
 */
export interface ShadowComponentCriterionDetail {
    /**
     * 
     * @type {string}
     * @memberof ShadowComponentCriterionDetail
     */
    criteria_id: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowComponentCriterionDetail
     */
    query: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowComponentCriterionDetail
     */
    result: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowComponentCriterionDetail
     */
    qualifier: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShadowComponentCriterionDetail
     */
    is_medication_rule: boolean;
    /**
     * 
     * @type {number}
     * @memberof ShadowComponentCriterionDetail
     */
    score_contribution: number;
}

/**
 * Check if a given object implements the ShadowComponentCriterionDetail interface.
 */
export function instanceOfShadowComponentCriterionDetail(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "criteria_id" in value;
    isInstance = isInstance && "query" in value;
    isInstance = isInstance && "result" in value;
    isInstance = isInstance && "qualifier" in value;
    isInstance = isInstance && "is_medication_rule" in value;
    isInstance = isInstance && "score_contribution" in value;

    return isInstance;
}

export function ShadowComponentCriterionDetailFromJSON(json: any): ShadowComponentCriterionDetail {
    return ShadowComponentCriterionDetailFromJSONTyped(json, false);
}

export function ShadowComponentCriterionDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowComponentCriterionDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'criteria_id': json['criteria_id'],
        'query': json['query'],
        'result': json['result'],
        'qualifier': json['qualifier'],
        'is_medication_rule': json['is_medication_rule'],
        'score_contribution': json['score_contribution'],
    };
}

export function ShadowComponentCriterionDetailToJSON(value?: ShadowComponentCriterionDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'criteria_id': value.criteria_id,
        'query': value.query,
        'result': value.result,
        'qualifier': value.qualifier,
        'is_medication_rule': value.is_medication_rule,
        'score_contribution': value.score_contribution,
    };
}

